import {sortBy} from "lodash"
import $ from "jquery"
import {paramById, paramCallback} from 'help@/store'
import Vue from 'vue'
import VueScrollTo from 'vue-scrollto'
import {removeItemById, updateOrAddItemById} from 'help@/store'

// mutations
const mutations = {
    setSortedParameter(state, id) {
        state.sortedParameters.splice(state.sortedParameters.length, 1, id)
    },

    setHidden(state, {id, hidden}) {
        let param = paramById(state.groups, id)
        param['hidden'] = hidden
    },

    updateDependants() {},

    fillOrigins(state) {
        paramCallback(state.groups, (param) => {
            if (param.hasOwnProperty('dependent_from_parameter_id')
                && param.dependent_from_parameter_id) {
                if (state.origins.indexOf(param.dependent_from_parameter_id) === -1) {
                    state.origins.push(param.dependent_from_parameter_id)
                }
            }
        })
    },

    fillGroupsForMachineryType(state, groups) {
        state.groups = groups
    },

    updateRequiredFields(state, payload) {
        if (payload.add) {
            state.requiredFields.splice(state.requiredFields.length, 1, payload.parameterId)
        } else {
            state.requiredFields.splice(state.requiredFields.indexOf(payload.parameterId), 1)
            removeItemById(state.errors, payload.parameterId)
        }
    },

    setResourceUrl(state, value) {
        state.resourceUrl = value;
    },

    setScrolled(state, value) {
        state.scrolled = value
    },

    scrolling(state) {
        if (state.errors.length && !state.scrolled) {
            const element = sortBy(state.errors, [e => state.sortedParameters.indexOf(e.id)])[0]
            const selector = '#field_' + element.id
            VueScrollTo.scrollTo(selector, 300, {
                offset: -25
            })
            state.scrolled = true
            $(selector).focus()
        }
        return !!state.errors.length
    },

    addError(state, error) {
        updateOrAddItemById(state.errors, error)
    },

    removeError(state, parameterId) {
        removeItemById(state.errors, parameterId)
    },

    setEmptyFormData(state, parameterId) {
        state.formData[parameterId] = undefined
    },

    fillEditFormData(state, payload) {
        let formData = {}
        for (const id in payload) {
            if (
                payload.hasOwnProperty(id)
                && paramById(state.groups, id)
            ) formData[id] = payload[id]
        }
        state.formData = formData
    },

    updateFormStatus(state, status) {
        state.formStatus = status
    },

    updateFormData(state, payload) {
        Vue.set(state.formData, payload.key, payload.value)
    },

    updateExtra(state, payload) {
        paramCallback(state.groups, (param) => {
            if (param.id === payload.id) param['extra_serialized'] = payload.extra
        })
    },

    setHideStatus(state, payload) {
        paramCallback(state.groups, (param) => {
            if (param.id === payload.id) param.hideStatus = payload.status
        })
    },

    setGlobalExtra(state, globalExtra) {
        state.globalExtra = globalExtra
    },

    updateIsMobile(state, isMobile) {
        state.isMobile = isMobile
    },
}

export default mutations
